import { Route } from '@angular/router';

export const ROSTER_ROUTES: Route[] = [
  { path: '', loadComponent: () => import('./components/roster/roster.component').then(m => m.RosterComponent) }
];
